module.exports = {
  id: 17,
  name: 'Burpees',
  categories: ['cardio', 'strength', 'fullBody'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'football',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'advanced',
  skill: 'Full Body',
  points: 20,
  instructions:
    "Burpees make you super strong and fast! Ok ninja, your mission is to sneak into a zoo! Stand up, squat down, put your hands on the ground, jump your feet back into push up position, do a push-up, jump your feet forward, then jump up! Let's try it, ninja!",
  timedInstructions: [
    {
      time: 0,
      text: 'Stand up, squat down, put your hands on the ground, jump your feet back into push up position, do a push-up, jump your feet forward, then jump up!',
    },
    {
      time: 5,
      text: 'Squat down, feet apart!',
    },
    {
      time: 7,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 9,
      text: 'Do a push up, chest to ground!',
    },
    {
      time: 11,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 13,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 15,
      text: 'Squat down, hide from monkeys!',
    },
    {
      time: 17,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 19,
      text: 'Do a push up, keep your body straight!',
    },
    {
      time: 21,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 23,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 25,
      text: 'Squat down, feet apart!',
    },
    {
      time: 27,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 29,
      text: 'Do a push up, chest to ground!',
    },
    {
      time: 31,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 33,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 35,
      text: 'Squat down, hide from tigers!',
    },
    {
      time: 37,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 39,
      text: 'Do a push up, keep your body straight!',
    },
    {
      time: 41,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 43,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 45,
      text: 'Squat down, feet apart!',
    },
    {
      time: 47,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 49,
      text: 'Do a push up, chest to ground!',
    },
    {
      time: 51,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 53,
      text: 'Jump up high, arms raised!',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 55,
      text: 'Amazing job, zoo ninja! Take a good break now',
    },
    {
      time: 58,
      text: 'Breathe in and out, catch your breath',
    },
    {
      time: 61,
      text: "You just did 10 burpees, that's incredible!",
    },
    {
      time: 64,
      text: 'Your full body is getting so strong!',
    },
    {
      time: 67,
      text: 'Remember to keep your body straight during push-ups',
    },
    {
      time: 70,
      text: 'Keep your chest close to the ground',
    },
    {
      time: 73,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 76,
      text: "You're building amazing strength and speed!",
    },
    {
      time: 79,
      text: 'Ready for round two, ninja warrior!',
    },
    {
      time: 82,
      text: '3, 2, 1, CONTINUE TRAINING!',
    },
    // SET 2: PIZZA DELIVERY MISSION
    {
      time: 67,
      text: 'Mission: Deliver pizza to the castle!',
    },
    {
      time: 69,
      text: 'Squat down, feet apart!',
    },
    {
      time: 71,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 73,
      text: 'Do a push up, chest to ground!',
    },
    {
      time: 75,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 77,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 79,
      text: 'Squat down, hide from dragons!',
    },
    {
      time: 81,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 83,
      text: 'Do a push up, keep your body straight!',
    },
    {
      time: 85,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 87,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 89,
      text: 'Squat down, feet apart!',
    },
    {
      time: 91,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 93,
      text: 'Do a push up, chest to ground!',
    },
    {
      time: 95,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 97,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 99,
      text: 'Squat down, hide from knights!',
    },
    {
      time: 101,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 103,
      text: 'Do a push up, keep your body straight!',
    },
    {
      time: 105,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 107,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 109,
      text: 'Squat down, feet apart!',
    },
    {
      time: 111,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 113,
      text: 'Do a push up, chest to ground!',
    },
    {
      time: 115,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 117,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 119,
      text: 'Squat down, hide from the wizard!',
    },
    {
      time: 121,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 123,
      text: 'Do a push up, keep your body straight!',
    },
    {
      time: 125,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 127,
      text: 'Jump up high, arms raised!',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 129,
      text: 'Amazing job, pizza ninja! Take another break',
    },
    {
      time: 132,
      text: 'Breathe in and out, feel your strength',
    },
    {
      time: 135,
      text: 'You just did 20 burpees total!',
    },
    {
      time: 138,
      text: 'Your full body is getting incredibly strong!',
    },
    {
      time: 141,
      text: 'Remember to keep your body straight during push-ups',
    },
    {
      time: 144,
      text: 'Keep your chest close to the ground',
    },
    {
      time: 147,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 150,
      text: "You're becoming a ninja master!",
    },
    {
      time: 153,
      text: 'Ready for round three, ninja champion!',
    },
    {
      time: 156,
      text: '3, 2, 1, ADVANCED TRAINING!',
    },
    // SET 3: SPACE MISSION
    {
      time: 159,
      text: 'Mission: Explore the alien planet!',
    },
    {
      time: 161,
      text: 'Squat down, feet apart!',
    },
    {
      time: 163,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 165,
      text: 'Do a push up, chest to ground!',
    },
    {
      time: 167,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 169,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 171,
      text: 'Squat down, hide from aliens!',
    },
    {
      time: 173,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 175,
      text: 'Do a push up, keep your body straight!',
    },
    {
      time: 177,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 179,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 181,
      text: 'Squat down, feet apart!',
    },
    {
      time: 183,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 185,
      text: 'Do a push up, chest to ground!',
    },
    {
      time: 187,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 189,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 191,
      text: 'Squat down, hide from space robots!',
    },
    {
      time: 193,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 195,
      text: 'Do a push up, keep your body straight!',
    },
    {
      time: 197,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 199,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 201,
      text: 'Squat down, feet apart!',
    },
    {
      time: 203,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 205,
      text: 'Do a push up, chest to ground!',
    },
    {
      time: 207,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 209,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 211,
      text: 'Squat down, hide from space dragons!',
    },
    {
      time: 213,
      text: 'Jump your feet back to plank!',
    },
    {
      time: 215,
      text: 'Do a push up, keep your body straight!',
    },
    {
      time: 217,
      text: 'Jump your feet forward to squat!',
    },
    {
      time: 219,
      text: 'Jump up high, arms raised!',
    },
    {
      time: 221,
      text: 'You did it, space ninja champion!',
    },
    {
      time: 223,
      text: 'Incredible work! You did 30 burpees!',
    },
    {
      time: 225,
      text: 'Your full body is incredibly strong!',
    },
    {
      time: 227,
      text: 'You are a ninja master!',
    },
  ],
};
